<template>
  <div>
    <h3>Muutama kysymys öljylämmittäjälle:</h3>
    <form @submit="onSubmit">
      <div class="form-group">
        <h4><label for="jst_oilAge">Mikä on nykyisen öljykattilan ikä?</label></h4>
        <input  type="number"
                name="jst_oil_age"
                id="jst_oil_age"
                v-model="form.oil.oilAge"
                min="0"
                max="100"
                step="1"
                required/><span>vuotta</span>
        <radio-group v-model="form.oil.location.value"
                  groupName="jst_location"
                  label="Missä öljysäiliö sijaitsee?"
                  :options="form.oil.location.options" required/>
        <radio-group v-model="form.oil.funnel.value"
                  groupName="jst_funnel"
                  label="Millainen on savuhormi?"
                  :options="form.oil.funnel.options" required/>
        <radio-group v-model="form.oil.burner.value"
                  groupName="jst_burner"
                  label="Milloin öljypoltin on uusittu viimeksi?"
                  :options="form.oil.burner.options" required/>
        <radio-group v-model="form.oil.consumption.value"
                  groupName="jst_consumption"
                  label="Mikä on vuosittainen öljykulutuksesi?"
                  :options="form.oil.consumption.options" required/>
      </div>
      <button type="submit" variant="primary">Jatka</button>
      <button type="button" @click="goBack">Takaisin</button>
      {{ answer }}
    </form>
  </div>
</template>
<script>
export default {
  props: [
    'formData',
  ],
  data() {
    const fields = {
      oil: {
        oilAge: '',
        location: {
          value: '3',
          options: [
            { text: 'Sisällä', value: 0 },
            { text: 'Ulkona maassa', value: 1 },
          ],
        },
        funnel: {
          value: '3',
          options: [
            { text: 'Teräs', value: 0 },
            { text: 'Vuorattu tiili', value: 1 },
            { text: 'Vuoraamaton tulihormi', value: 2 },
          ],
        },
        burner: {
          value: false,
          options: [
            { text: 'Alle 12 vuotta sitten', value: -1 },
            { text: 'Yli 12 vuotta sitten', value: 1 },
          ],
        },
        consumption: {
          value: false,
          options: [
            { text: 'Alle 1800 litraa vuodessa', value: 1 },
            { text: '1800-2500 litraa vuodessa', value: 2 },
            { text: 'Yli 2500 litraa vuodessa', value: 3 },
          ],
        },
      },
    };
    // Merge values
    const form = { ...fields, ...this.formData };
    return {
      form,
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.form.answer = this.countAnswers();
      this.$nextTick(() => {
        this.$emit('submitForm', this.form);
      });
    },
    goBack() {
      this.$nextTick(() => {
        this.$emit('goBack', this.form);
      });
    },
    countAnswers() {
      let x = 0;
      if (parseInt(this.form.oil.oilAge, 10) >= 25) {
        x = +1;
      }
      x = x + parseInt(this.form.oil.location.value, 10) + parseInt(this.form.oil.burner.value, 10);
      const l = parseInt(this.form.oil.consumption.value, 10);
      let answerPage = 0;
      switch (true) {
        case l === 1 && x < 2:
          answerPage = 10;
          break;
        case l === 1 && x >= 2:
          answerPage = 11;
          break;
        case l === 2 && x >= 2:
          answerPage = 12;
          break;
        case l === 2 && x < 2 && this.formData.area > 200:
          answerPage = 16;
          break;
        case l === 2 && x < 2:
          answerPage = 13;
          break;
        case l === 3 && x >= 2:
          answerPage = 14;
          break;
        case l === 3 && x < 2:
          answerPage = 15;
          break;
        default:
          break;
      }
      return answerPage;
    },
  },
};
</script>
<style lang="scss">
  form input::placeholder {
    color: lightgray !important;
  }
  #jst_oil_age {
    display: inline-block;
    max-width: 10rem;
    margin-right: 1rem;
  }
</style>
